// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__phrNG","footer":"ChangeClinic_footer__144Jr"};